import _sfc_main from "./index.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.showSettingDialog ? _c("div", { staticClass: "overlay-container overlay", on: { "click": _setup.handleOverlayClick } }, [_c("div", { staticClass: "setting-container" }, [_c("div", { staticClass: "setting-header" }, [_c("span", { staticClass: "setting-title" }, [_vm._v(_vm._s(_setup.t("Settings")))]), _c(_setup.SvgIcon, { staticClass: "close-icon", attrs: { "icon": _setup.CloseIcon }, on: { "click": _setup.handleCloseSettingDialog } })], 1), _c("div", { staticClass: "setting-body" }, [_c("div", { staticClass: "setting-tabs" }, _vm._l(_setup.settingTabsTitleList, function(item, index) {
    return _c("div", { key: index, class: [
      "tabs-title",
      `${_setup.activeSettingTab === item.value ? "active" : ""}`
    ], on: { "click": function($event) {
      return _setup.handleUpdateActiveTab(item.value);
    } } }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0), _c("div", { staticClass: "divide-line" }), _c("div", { staticClass: "setting-content" }, [_setup.activeSettingTab === "audio" ? _c(_setup.AudioSettingTab, { staticClass: "setting-tab", attrs: { "mode": _setup.SettingMode.DETAIL, "theme": "white" } }) : _setup.activeSettingTab === "video" ? _c(_setup.VideoSettingTab, { staticClass: "setting-tab", attrs: { "with-preview": true, "theme": "white" } }) : _vm._e()], 1)])])]) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "cadaf945"
);
const RoomSetting = __component__.exports;
export {
  RoomSetting as default
};
